import { createContext } from 'react';
import { ITeasers, TTeaserContentTypes } from 'types';

export type TTeasersSortBy = '' | 'CustomerA-Z' | 'CustomerZ-A' | 'ContentTypeA-Z' | 'ContentTypeZ-A';
export type TCountOfTeasers = '12' | '24' | '48';
export type TTypeOfModalWindow = null | 'toConfirmDeleteItem' | 'success' | 'error';
export interface IFilterValues {
	searchString: string;
	IDSelectedCustomer: Nullable<string>;
	IDSelectedRestaurant: Nullable<string>;
	IDSelectedContentType: Nullable<TTeaserContentTypes>;
	sortBy: TTeasersSortBy;
	countOfItems: TCountOfTeasers;
	currentPage: number;
}

export interface ITeasersState {
	teasers: ITeasers;
	searchString: string;
	IDSelectedCustomer: Nullable<string>;
	IDSelectedRestaurant: Nullable<string>;
	IDSelectedContentType: Nullable<TTeaserContentTypes>;
	sortBy: TTeasersSortBy;
	countOfItems: TCountOfTeasers;
	currentPage: number;
	teaserIDForDeletion: string;
	teaserIDForFullInfo: string;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const teasersInitialState: ITeasersState = {
	teasers: { teasersCount: 0, teasers: [] },
	searchString: '',
	IDSelectedCustomer: null,
	IDSelectedRestaurant: null,
	IDSelectedContentType: null,
	sortBy: '',
	countOfItems: '12',
	currentPage: 1,
	teaserIDForDeletion: '',
	teaserIDForFullInfo: '',
	typeOfModalWindow: null,
};

export interface ITeasersContext extends ITeasersState {
	deleteSelectedItem(): void;
	setIDCustomer(value: Nullable<string>): void;
	setIDRestaurant(value: Nullable<string>): void;
	setIDContentType(value: Nullable<TTeaserContentTypes>): void;
	resetSelectedControls(): void;
	setSortBy(sortBy: TTeasersSortBy): void;
	setCountOfItems(count: TCountOfTeasers): void;
	changeCurrentPage(page: number): void;
	setTeaserIDForDeletion(teaserID: string): void;
	setTeaserIDForFullInfo(teaserID: string): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	setFiltersFromQueryString(value: IFilterValues): void;
}

export const TeasersContext = createContext<ITeasersContext>({
	deleteSelectedItem: () => undefined,
	setIDCustomer: () => undefined,
	setIDRestaurant: () => undefined,
	setIDContentType: () => undefined,
	resetSelectedControls: () => undefined,
	setSortBy: () => undefined,
	setCountOfItems: () => undefined,
	changeCurrentPage: () => undefined,
	setTeaserIDForDeletion: () => undefined,
	setTeaserIDForFullInfo: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	setFiltersFromQueryString: () => undefined,
	...teasersInitialState,
});
